const $ = require('jquery');

$(function () {
  const sharing = $('.sharing');
  const backdrop = $('.sharing__backdrop');

  if (sharing[0]) {
    $(sharing).on('click', function () {
      $(backdrop).addClass('!flex');
      setTimeout(() => {
        $(backdrop).attr('data-shown', '1');
      }, 50);
    });
  }

  $(document).on('keydown', function (event) {
    const isEscKeyed = event.key === 'Escape' || event.key === 27;
    const isModalOpen = $(backdrop).attr('data-shown') === '1';
    if (isEscKeyed && isModalOpen) {
      $(backdrop).removeClass('!flex');
      $(backdrop).attr('data-shown', '0');
    }
  });

  $(document).on('click', function (event) {
    const isModalOpen = $(backdrop).attr('data-shown') === '1';
    if (isModalOpen) {
      const clickedBackdrop = $(event.target).closest('.sharing__container').length === 0;
      if (clickedBackdrop) {
        $(backdrop).removeClass('!flex');
        $(backdrop).attr('data-shown', '0');
      }
    }
  });
});
